(function() {
	
	var AddToList = function() {
		$('#add_to_list_dialog').on('hidden.bs.modal', function () {
			$('#add_to_list_dialog .modal-dialog').html("");
		})

		var self = this;
		$('.add-to-list-link').on('click', function() {
			var product_id = $(this).data('product-id');
			var url = $(this).data('url');
			self.loadDialogContent($(this), product_id, url);
		});
	};

	AddToList.prototype = {
		
		loadDialogContent: function(linkElem, product_id, url) {
			var self = this;
			$.ajax(url, {
				success: function(data) {
					$("#add_to_list_dialog .modal-dialog").html(data);
					
					// Adding multiple products from cart
					if ($(".add-to-list .add-to-list-input").length) {
						$(".add-to-list .add-to-list-input").each(function(index) {
							$("#add_to_list_dialog .add-to-list-form").append($(this));
						});
					}
					// Adding product from search/product page 
					else {
						var quantity = linkElem.closest('.add-to-links').siblings('.product-add-to-cart').find('.quantity').val();
						var id_input = '<input type="hidden" name="shopping_cart_items[0][id]" class="add-to-list-product-input" id="product_id" value="'+product_id+'">';
						var quantity_input = '<input type="hidden" name="shopping_cart_items[0][quantity]" class="add-to-list-product-input" id="product_quantity" value="'+quantity+'">';
						$("#add_to_list_dialog .add-to-list-form").append(id_input);
						$("#add_to_list_dialog .add-to-list-form").append(quantity_input);
						
						//Append grouped products
						if ($(".grouped-products").length) {
							if ($(".parent-not-purchasable").length) {
								// Remove the parent inputs that were appended
								$("#add_to_list_dialog .add-to-list-form .add-to-list-product-input").remove();
								
								// Create inputs for each of the child products
								$(".grouped-products .parent-not-purchasable .grouped-product-quantity").each(function() {
									var quantity = parseFloat($(this).val());
									if (!isNaN(quantity) && quantity > 0) {
										var input = $(this).clone();
										input.attr('type', 'hidden');
										input.attr('name', input.attr('name').replace('products', 'shopping_cart_items'));
										$("#add_to_list_dialog .add-to-list-form").append(input);
										$("#add_to_list_dialog .add-to-list-form").append("<input type='hidden' name='shopping_cart_items["+$(this).data('index')+"][id]' value='"+$(this).data('id')+"' />");
									}
								});
							} else {
								$(".grouped-products .product-quantity").each(function() {
									$("#add_to_list_dialog .add-to-list-form").append("<input type='hidden' name='shopping_cart_items[0][children]["+$(this).attr('name')+"]' value='"+$(this).val()+"' />");
								});
							}
						}
					}
					
					// Set up new list form validator
					var validator = new C.FormValidator('form#addToNewShoppingListForm');
					$('form#addToNewShoppingListForm').on('submit', function(event) {
						if(!validator.isValid()) {
							event.preventDefault();
						}
					});
					self.toggle_forms();
				}
			});
		},
		
		toggle_forms: function() {
			$('input[name=list_type][type=radio]').on('change', function() {
				if (this.value == 'new') {
					$("#addToExistingListInputs").hide();
					$("#addToNewListInputs").show();
				} else {
					$("#addToExistingListInputs").show();
					$("#addToNewListInputs").hide();
				}
			});
		},
		
		submitAddToListForm: function() {
			// Submit correct form based on radio buttons
			if ($('input[name=list_type]:checked').val() == 'new' || $('input[name=list_type]').length === 0) { // creating new list
				var form = $("#addToNewShoppingListForm");
			} else { // adding to existing list
				$("#addToExistingShoppingListForm").attr('action', $('#shopping_cart_names').find(":selected").data('url'))
				var form = $("#addToExistingShoppingListForm");
			}
			
			// Append product customization inputs
			// Only supports adding 1 customized product to list at a time
			if ($("#product_customizations").length) {
				$(".customization-field").each(function(i) {
					form.append("<input type='hidden' name='shopping_cart_items[0][product_customizations]["+i+"][id]' value='"+$(this).data('id')+"' />");
					form.append("<input type='hidden' name='shopping_cart_items[0][product_customizations]["+i+"][value]' value='"+$(this).val()+"' />");
					form.append("<input type='hidden' name='shopping_cart_items[0][product_customizations]["+i+"][label]' value='"+$(this).data('label')+"' />");
					form.append("<input type='hidden' name='shopping_cart_items[0][product_customizations]["+i+"][price]' value='"+($(this).data('price') || 0)+"' />");
				});
			}
			
			form.submit();
		}
	};

	C.AddToList = AddToList;
	
})();